<template>
  <section class="myhome-con mgt10 mgb10 mgl10 mgr10">
    <div class="tit-box type1">
      <h1 class="tit-type1">회원정보</h1>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>성명</th>
        <td class="last">{{ mberNm }}</td>
      </tr>
      <tr>
        <th>생년월일</th>
        <td class="last">{{ $cmmn.date.getYmdFormat(mberBthd) }}</td>
      </tr>
      <tr>
        <th>휴대폰번호</th>
        <td class="last"
            style="line-height: 25px;">{{ mbpnTlno }}
          <btn :txt="'변경'"
               :size="'ssmall'"
               :color="'white'"
               @click="btnMbpnTlnoChng_click"/>
          <span class="pc01 mgl10">* 안내 및 각종 알림 문자를 받으실 휴대폰 번호를 입력해주세요.</span>
        </td>
      </tr>
      <tr>
        <th>아이디</th>
        <td class="last">{{ mberId }}</td>
      </tr>
      <tr>
        <th>비밀번호</th>
        <td class="last"
            style="line-height: 25px;">
          ※ 보안을 위해 <span class="pc01">정기적인 비밀번호 변경</span>을 권장합니다.
          <btn :txt="'변경'"
               :size="'ssmall'"
               :color="'white'"
               @click="btnPswdChng_click"/>
        </td>
      </tr>
      <tr>
        <th>이메일</th>
        <td class="last"
            style="line-height: 25px;">{{ mberEmail }}
          <btn :txt="'변경'"
               :size="'ssmall'"
               :color="'white'"
               @click="btnEmailChng_click"/>
        </td>
      </tr>
      <tr>
        <th>회원탈퇴</th>
        <td class="last">
          <btn :txt="'회원탈퇴'"
               :size="'ssmall'"
               :color="'white'"
               @click="btnMberSecsn_click"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="tit-box type1">
      <h1 class="tit-type1">정보수신동의</h1>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:20%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>SMS 수신동의</th>
        <td class="last">
          <input type="checkbox"
                 id="smsRcpnAgreAt"
                 true-value="Y"
                 false-value="N"
                 v-model="smsRcpnAgreAt"
                 @change="rdbxRcpnAgreAt_change"/>
          <label for="smsRcpnAgreAt"><span class="box"></span>동의 여부</label>
        </td>
      </tr>
      <tr>
        <th>이메일 수신동의</th>
        <td class="last">
          <input type="checkbox"
                 id="emailRcpnAgreAt"
                 true-value="Y"
                 false-value="N"
                 v-model="emailRcpnAgreAt"
                 @change="rdbxRcpnAgreAt_change"/>
          <label for="emailRcpnAgreAt"><span class="box"></span>동의 여부</label>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
  <self-crtfc ref="selfCrtfcRef" @callback="selfCrtfcCallback"/>
</template>

<script setup>
import MberPswdChng from "@/views/my-info/mber-pswd-chng.vue";

import {computed, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";
import MberEmailChng from "@/views/my-info/mber-email-chng.vue";

const {$mber, $loading} = getStore();
const {$popup, $axios, $cmmn, $alert, $confirm} = getUtils();

const mberSn = computed(() => $mber.mberSn);

const selfCrtfcRef = ref();

const btnMbpnTlnoChng_click = async () => {
  try {
    $loading.on();

    selfCrtfcRef.value.showSelfCrtfc();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const selfCrtfcCallback = async (result) => {
  $loading.on();

  try {
    const { nm, bthd, mbpnTlno } = result;
    if (mberNm.value != nm || mberBthd.value != bthd) {
      await $alert('회원가입 시 입력한 이름, 생년월과 본인인증을 통해 확인된 이름, 생년월일이 일치하지 않습니다.');
      return false;
    }

    const params = {
      mberSn: mberSn.value,
      mbpnTlno,
      udmbSn: mberSn.value,
    };

    await $axios.post('/api/mber/mber-mbpn-tlno', params);
    await $alert('휴대폰번호가 변경되었습니다.');
    await getMberByMberSn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
  /*
  * mberNm
  * mberBthd
  * */
  /*if (result.isSelfCrtfc) {
    mberNm.value = result.nm;
    mberBthd.value = result.bthd;
    mbpnTlno.value = result.mbpnTlno;
    isSelfCrtfc.value = true;
  } else {
    console.error(result.errCd, result.errMssg);
    $alert(result.errMssg);
  }*/
}

const btnPswdChng_click = () => {
  const popupOpts = {
    header: '비밀번호 변경',
    contentStyle: {
      'width': '450px'
    },
  }
  const props = {'mberSn': mberSn.value};

  $popup.show(MberPswdChng, popupOpts, props);
}

const btnEmailChng_click = () => {
  const popupOpts = {
    header: '이메일 변경',
    contentStyle: {
      'width': '550px'
    },
  }
  const props = {'mberSn': mberSn.value, 'mberEmail': mberEmail.value};
  const emits = {'chng-compt': getMberByMberSn}

  $popup.show(MberEmailChng, popupOpts, props, emits);
}

const btnMberSecsn_click = async () => {
  const getFcltysParams = {
    mberSn: $mber.mberSn,
    svcId: $cmmn.svc.getSeroiSvcId(),
  }
  const fcltys = await $cmmn.fclty.getFcltysByMberSn(getFcltysParams);
  if (fcltys.length > 0) {
    await $alert('연결된 시설이 있어 회원 탈퇴할 수 없습니다. 시설 중지 또는 시설 회원 탈퇴 후 요청해 주세요.');
    return false;
  }

  const isConfirm = await $confirm('회원탈퇴 시 복구가 불가능합니다. 정말 탈퇴하시겠습니까?');
  if (!isConfirm) return false;

  const removeMberParams = {
    mberSn: $mber.mberSn,
    udmbSn: $mber.mberSn,
    svcId: $cmmn.svc.getSeroiSvcId(),
  }
  const {data} = await $axios.post('/api/mber/secsn', removeMberParams);

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 관리자에게 문의해 주세요.');
    return false;
  }

  await $alert('회원탈퇴가 정상적으로 처리되었습니다.');
  await $axios.post('/api/cmmn/user-lgout');
  $mber.clear();
  location.reload();
}

const mberNm = ref('');
const mberBthd = ref('');
const mbpnTlno = ref('');
const mberId = ref('');
const mberEmail = ref('');
const smsRcpnAgreAt = ref('');
const emailRcpnAgreAt = ref('');

const getMberByMberSn = async () => {
  const params = {
    mberSn: mberSn.value
  };
  const {data} = await $axios.get('/api/mber/by-mber-sn', {params});

  mberNm.value = data.mberNm;
  mberBthd.value = data.mberBthd;
  mbpnTlno.value = data.mbpnTlno;
  mberId.value = data.mberId;
  mberEmail.value = data.mberEmail;
  smsRcpnAgreAt.value = data.smsRcpnAgreAt;
  emailRcpnAgreAt.value = data.emailRcpnAgreAt;
}

const rdbxRcpnAgreAt_change = async () => {
  try {
    $loading.on();

    const modifyRcpnAgreParams = {
      mberSn: mberSn.value,
      smsRcpnAgreAt: smsRcpnAgreAt.value,
      emailRcpnAgreAt: emailRcpnAgreAt.value,
      udmbSn: mberSn.value
    };

    await modifyMberRcpnAgreAt(modifyRcpnAgreParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const modifyMberRcpnAgreAt = async ({mberSn, smsRcpnAgreAt, emailRcpnAgreAt, udmbSn}) => {
  const {data} = await $axios.post('/api/mber/rcpn-agre-at', {mberSn, smsRcpnAgreAt, emailRcpnAgreAt, udmbSn});

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await $alert('저장되었습니다.');
  await getMberByMberSn();
}

onMounted(async () => {
  try {
    $loading.on();

    await getMberByMberSn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
